import * as React from 'react'

//  assets
import DownIcon from '../../../../assets/img/dropdown-down-icon.png'
import UpIcon from '../../../../assets/img/dropdown-up-icon.png'

// containers
import MapContainer from '../../containers/MapContainer'

// components
import Icon from '../../../../components/ui/Icon/Icon'
import {
  Content,
  Header,
  MainPage,
  MapWrapper,
  Note,
  ReturnIcon,
  Route,
  Routes,
  RouteDescription,
  RouteGroup,
  RouteUnavailable,
  RouteHeader,
  RouteHeaderLeft,
  RouteHeaderRight,
  RouteItem,
  RouteItemLeft,
  RouteItemRight,
  RouteSchedules,
  RouteTitle,
  Title,
} from './TransportationRoutes.style'

// data
import {
  TRANSPORTATION,
  FILTER_LOCATION,
} from '../../../../services/data/profilePages.json'

// controllers
import {
  doGetMallRoutes,
  doGetLocationRoutes,
} from '../../../../controllers/Transportaion'

class TransportationRoutes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // TODO: define initial state
      routes: null,
      contactId: '',
      locationName: '',
    }
    const { transportationMall, accessToken } = this.props
    // TODO: implement constructor(props)

    if (transportationMall) {
      if (transportationMall.type === 'mall') {
        doGetMallRoutes({
          accessToken,
          mallId: transportationMall.id,
          onSuccess: response => {
            const data = response.data
              .sort(this.sortRoute)
              .reduce(this.decoupleUnavailableRoute, [[], []])
            this.setState({
              routes: data[0].concat(data[1]),
            })
          },
          onError: error => {
            const { errors: errorsObj } = this.state
            // errorsObj.mallRoutesError = error.message
            this.setState({ errors: errorsObj })
          },
        })
      } else if (transportationMall.type === 'location') {
        doGetLocationRoutes({
          locationId: transportationMall.id,
          onSuccess: response => {
            const data = response.data
              .sort(this.sortRoute)
              .reduce(this.decoupleUnavailableRoute, [[], []])
            this.setState({
              routes: data[0].concat(data[1]),
              locationName: transportationMall.locationName,
            })
          },
          onError: error => {
            const { errors: errorsObj } = this.state

            // errorsObj.mallRoutesError = error.message
            this.setState({ errors: errorsObj })
          },
        })
      }
    } else {
      console.error('No transportationMall found')
    }
  }

  toggleRoute(id, index) {
    const route = this.state.routes
    route[id].routes[index].active =
      route[id].routes[index].active != null
        ? !route[id].routes[index].active
        : true
    this.setState({
      routes: route,
    })
  }

  decoupleUnavailableRoute = (routes, route, index, array) => {
    if (route.routes[0].available && route.routes[1].available) {
      routes[0].push(route)
    } else if (route.routes[0].available) {
      routes[0].push({ id: index, routes: [route.routes[0]] })
      routes[1].push({ id: array.length + index, routes: [route.routes[1]] })
    } else if (route.routes[1].available) {
      routes[0].push({ id: index, routes: [route.routes[1]] })
      routes[1].push({ id: array.length + index, routes: [route.routes[0]] })
    } else {
      routes[1].push(route)
    }

    return routes
  }

  sortRoute = (a, b) => {
    if (a.routes[0].available && a.routes[1].available) return -1
    // both routes available for a
    else if (
      (a.routes[0].available && !a.routes[1].available) ||
      (!a.routes[0].available && a.routes[1].available) // only 1 route available for a
    ) {
      if (b.routes[0].available && b.routes[1].available) return 1
      // both routes available for b
      else return -1
    } else {
      if (b.routes[0].available && b.routes[1].available) return 1
      // both routes available for b
      else if (
        (b.routes[0].available && !b.routes[1].available) ||
        (!b.routes[0].available && b.routes[1].available)
      )
        return 1
      // only 1 route available for b
      else return 0
    }
  }

  componentDidMount() {
    // TODO: implement componentDidMount()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // TODO: implement componentDidUpdate(prevProps, prevState, snapshot)
  }

  handleClickRoute = ({
    contactId,
    mallSlug,
    location,
    route,
    accessToken,
  }) => {
    if (!accessToken) return
  }

  render() {
    const { transportationMall, setProfileModalPage, accessToken } = this.props
    // TODO: define template
    // let sortedRoutes = []
    // if (this.state.routes) sortedRoutes = this.state.routes.sort(this.sortRoute)
    if (transportationMall) {
      return (
        <>
          <MainPage show="true" /*show={!selectedFAQ}*/>
            <Header>
              <ReturnIcon
                onClick={() =>
                  transportationMall.type === 'mall'
                    ? setProfileModalPage(TRANSPORTATION)
                    : setProfileModalPage(FILTER_LOCATION)
                }
              >
                <Icon name="slide-left" />
              </ReturnIcon>
              <Title>{transportationMall.name}</Title>
            </Header>
            <Content>
              {this.state.routes && (
                <>
                  <Note>
                    {this.state.routes.length
                      ? 'Note: Senior Citizen / Students / PWD discounts will apply upon  payment.'
                      : transportationMall.type === 'mall'
                      ? 'There are no routes for this mall.'
                      : 'There are no routes for this location.'}
                  </Note>
                  <Routes>
                    {this.state.routes.map((item, id) => {
                      return (
                        <RouteGroup>
                          {item.routes.map((route, index) => {
                            return (
                              <Route>
                                {route.available === false && (
                                  <RouteUnavailable>
                                    This route is temporarily unavailable
                                  </RouteUnavailable>
                                )}
                                <RouteHeader
                                  onClick={() => {
                                    this.toggleRoute(id, index)
                                    this.handleClickRoute({
                                      contactId: `${this.state.contactId}`,
                                      mallSlug:
                                        transportationMall.type === 'location'
                                          ? null
                                          : transportationMall.mallSlug,
                                      location:
                                        transportationMall.type === 'location'
                                          ? this.state.locationName
                                          : null,
                                      route: `${route.origin} to ${route.destination}`,
                                      accessToken: accessToken,
                                    })
                                  }}
                                >
                                  <RouteHeaderLeft>
                                    <RouteTitle>
                                      {route.origin} to {route.destination}
                                    </RouteTitle>
                                    <RouteDescription>
                                      {route.description}
                                    </RouteDescription>
                                  </RouteHeaderLeft>
                                  <RouteHeaderRight>
                                    <img
                                      src={
                                        route.active != null &&
                                        route.active === true
                                          ? UpIcon
                                          : DownIcon
                                      }
                                      alt="Select"
                                    />
                                  </RouteHeaderRight>
                                </RouteHeader>
                                {route.active != null && route.active === true && (
                                  <>
                                    <MapWrapper>
                                      <MapContainer
                                        lat={route.latitude}
                                        lon={route.longitude}
                                      />
                                    </MapWrapper>
                                    <RouteSchedules>
                                      {route.schedules.length > 0 &&
                                        route.schedules.map(schedule => {
                                          return (
                                            <RouteItem>
                                              <RouteItemLeft>
                                                {schedule.days}
                                              </RouteItemLeft>
                                              <RouteItemRight>
                                                {schedule.departure}
                                              </RouteItemRight>
                                            </RouteItem>
                                          )
                                        })}
                                    </RouteSchedules>
                                    <RouteItem
                                      isLastChild={
                                        !(
                                          route.remarks &&
                                          route.remarks.length > 0
                                        )
                                      }
                                    >
                                      <RouteItemLeft>
                                        Standard Fee:
                                      </RouteItemLeft>
                                      <RouteItemRight>
                                        ₱ {route.fare}
                                      </RouteItemRight>
                                    </RouteItem>
                                    {route.remarks && route.remarks.length > 0 && (
                                      <RouteItem isLastChild={true}>
                                        <RouteItemLeft>Remarks:</RouteItemLeft>
                                        <RouteItemRight>
                                          {route.remarks}
                                        </RouteItemRight>
                                      </RouteItem>
                                    )}
                                  </>
                                )}
                              </Route>
                            )
                          })}
                        </RouteGroup>
                      )
                    })}
                  </Routes>
                </>
              )}
            </Content>
          </MainPage>
        </>
      )
    } else {
      return (
        <MainPage show="true" /*show={!selectedFAQ}*/>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(TRANSPORTATION)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>Sorry!</Title>
          </Header>
          <Content>
            <>We're having trouble getting info at this moment.</>
          </Content>
        </MainPage>
      )
    }
  }
}

TransportationRoutes.defaultProps = {
  // TODO: specify default props
}

TransportationRoutes.propTypes = {
  // TODO: specify prop types
}

export default TransportationRoutes
